import React from "react";
import ReportWorkspace from "./ReportWorkspace";

const ReportPayment = props => <ReportWorkspace type="payment" history={props.history} />;

export default ReportPayment;
